import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import RplyComp from './RplyComp';
import { host } from './script/variables';

const CommentPage = (props) => {

    const [params, setParams] = useSearchParams()
    const [commentCount,setCommentCount] = useState(0)
    const cafeId = params.get('cid')
    const [isLogin,setIsLogin] = useState(true)

    useEffect(()=>{
        console.log(cafeId)
    },[])
  return (
    <div>
       {/* <Comments postid={cafeId} setCommentCount={setCommentCount} commentCount={commentCount} isLogin={isLogin} />  */}
       <RplyComp />
    </div>
  )
}

export default CommentPage
